// Module
var code = `<div class="w-100 h-100"> </div> `;
// Exports
module.exports = code;